module.exports = __webpack_public_path__ + "img/user.3e201ef4.svg";